/// <amd-module name="Feed/Legacy/Components/EmptyFeedPanel" />
import * as React from "react";

import * as Utils_String from "VSS/Core/Util/String";

import { ConnectToFeedButton } from "Feed/Legacy/Components/ConnectToFeedButton";
import { ExternalLink } from "Feed/Legacy/Components/ExternalLink";
import { CustomerIntelligenceHelper } from "Feed/Legacy/Helpers/CustomerIntelligenceHelper";
import * as UrlHelper from "Feed/Legacy/Helpers/UrlHelper";
import { IPackageProtocol } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { HubAction } from "Feed/Legacy/Types/IHubState";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

import { CiConstants } from "Feed/Common/Constants/Constants";
import { FeedView } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IEmptyFeedPanelProps {
    pageContext: IVssPageContext;
    feed: Feed;
    feedViews: FeedView[];
    protocolMap: { [key: string]: IPackageProtocol };
}

export class EmptyFeedPanel extends React.PureComponent<IEmptyFeedPanelProps> {
    public render(): JSX.Element {
        const imagePath = UrlHelper.getVersionedContentUrl(
            this.props.pageContext,
            "ms.feed/packagelist/zerodata-connect-to-feed.svg"
        );

        return (
            <div className="empty-feed-panel">
                <img className="empty-feed-panel-image" src={imagePath} alt={""} />
                <div className="empty-feed-panel-text">{PackageResources.EmptyFeedPanel_Message}</div>
                <ConnectToFeedButton
                    pageContext={this.props.pageContext}
                    feed={this.props.feed}
                    feedViews={this.props.feedViews}
                    protocolMap={this.props.protocolMap}
                    isCallToAction={true}
                    hubAction={HubAction.Feed}
                />
                <ExternalLink
                    pageContext={this.props.pageContext}
                    href={PackageResources.EmptyFeedPanel_PackageManagementLearnMoreLink}
                    className="empty-feed-panel-link-text"
                    ciContext={CiConstants.EmptyFeedPanel}
                    onClick={() =>
                        CustomerIntelligenceHelper.publishEvent(
                            this.props.pageContext,
                            CiConstants.EmptyFeedLearnMoreLinkClicked
                        )
                    }
                >
                    {Utils_String.format(
                        PackageResources.EmptyFeedPanel_PackageManagementLearnMoreLinkText,
                        PackageResources.AzureArtifacts
                    )}
                </ExternalLink>
            </div>
        );
    }
}
